export enum EditorType {
  CONTENT,
  BRAINSTORM,
  TOOLKIT,
  CAMPAIGN,
  WEBSITE,
}
